import React, { useState, useEffect, useRef } from 'react';
import { Card, Form, Button, Spinner } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { Link, useParams, useNavigate} from 'react-router-dom';
import { useProvider, Toast } from '../context/MenuProvider';

import Home from '../components/Checkout/Home';
import SelecionarCliente from '../components/Checkout/SelecionarCliente';
import AdicionarProdutos from '../components/Checkout/AdicionarProdutos';


const Checkout = () => {
    const navigate = useNavigate();
    const [inicializado, setInicializado] = useState(false);
    const [venda, setVenda] = useState({});
    const { tipo, id } = useParams(); 
    const {
      buscarDadosPorId,
      salvarDados,
      hasPerms,
    } = useProvider();
    
    //Atualização
    useEffect(() => {
      const qtd = venda?.itens?.reduce((acc, x) => acc + parseFloat(x.quantidade || 0), 0) || 0;
      const vTotal = (
        venda?.itens?.reduce((acc, x) => acc + parseFloat((x.valor || 0) * (x.quantidade || 0)), 0) || 0
      ).toFixed(2);
    
      setVenda((prevVenda) => ({
        ...prevVenda,
        quantidade: qtd,
        total: vTotal,
        taxas: prevVenda.taxas == null ? (0).toFixed(2) : prevVenda.taxas,
        desconto: prevVenda.desconto == null ? (0).toFixed(2) : prevVenda.desconto,
        data: prevVenda.data == null ? new Date().toLocaleDateString('pt-BR').split('/').reverse().join('-') : prevVenda.data,
      }));
    }, [venda?.itens]); // Apenas monitora `venda?.itens` para evitar loops desnecessários
    
    
    
    // const salvarCheckout = async () => {
    //     //alert(`Salvando: ${JSON.stringify(venda)}`)
    //     await salvarDados('local_registros', { 
    //       ...venda,
    //       id:"checkout",
    //     });
    // };
    
    const carregarCheckout = async () => {
      try {
        const response = await buscarDadosPorId('local_registros', 'checkout');
        if (response) {
          //alert(JSON.stringify(response))
          setVenda(response);
          //alert(JSON.stringify(response?.venda?.cliente))
          //alert(JSON.stringify(response?.venda?.itens))
        } else {
          //alert(`Response: ${JSON.stringify(response)}`)
          console.warn('Response não é um array ou está vazio');
        }
      } catch (error) {
        //alert(`Catx: ${error}`)
        //alert(error)
        console.error('Erro ao carregar checkout:', error);
      }
    };
    

    // useEffect(() => {
    //   if (venda?.cliente || venda?.itens || venda?.pagamentos) {
    //     salvarCheckout();
    //   }
    // }, [venda?.cliente, venda?.itens, venda?.pagamentos]);
    
    useEffect(()=>{
      carregarCheckout();
    }, [])

    return (
      <>
        {((!tipo || id) && hasPerms('loja.view_venda')) && <Home id={id} venda={venda} setVenda={setVenda} />}
        {(tipo=="selecionar-cliente" && hasPerms('loja.view_clientes')) && <SelecionarCliente venda={venda} setVenda={setVenda} />}
        {(tipo=="adicionar-produtos" && hasPerms('loja.view_produtos')) && <AdicionarProdutos venda={venda} setVenda={setVenda} />}
      </>
    );
};

export default Checkout;